// @ts-nocheck

export const RelatoCroqui = async (data: any) => {
  return `O local dos fatos, trata-se de ${
    croqui.localSinistro[data.localSinistro] || '[..]'
  } de via ${croqui.viaTexto[data.via] || '[..]'}; ${
    croqui.pavimentacao[data.pavimentacao] || '[..]'
  }, com ${croqui.maoTexto[data.mao] || '[..]'}, ${
    croqui.tipoTrecho[data.tipoTrecho] || '[..]'
  }, em  ${croqui.nivel[data.nivel] || '[..]'}, ${
    croqui.acostamento[data.acostamento] || '[..]'
  },  ${croqui.permissaoEstacionar[data.permissaoEstacionar] || '[..]'}, ${
    croqui.area[data.area] || '[..]'
  }, ${croqui.sinalizacaoTexto[data.sinalizacao] || '[..]'}, com canteiro ${
    croqui.canteiroTexto[data.canteiro] || '[..]'
  }, com ${croqui.iluminacao[data.iluminacao] || '[..]'}, ${
    croqui.testemunhas[data.testemunhas] || '[..]'
  }, ${croqui.monitoramento[data.monitoramento] || '[..]'}, ${
    croqui.vigilancia[data.vigilancia] || '[..]'
  }, em um local ${croqui.localTexto[data.local] || '[..]'}.`;
};

export const croqui = {
  viaTexto: {
    publica: 'pública',
    privada: 'privada',
  },
  maoTexto: {
    duplo: 'sentido duplo de direção',
    unico: 'sentido único de direção',
    tresFaixas: 'três faixas',
    quatroFaixas: 'quatro faixas',
  },
  sinalizacaoTexto: {
    sim: 'com sinalização',
    nao: 'sem sinalização',
  },
  canteiroTexto: {
    central: 'central',
    lateral: 'lateral',
  },
  localTexto: {
    ermo: 'ermo',
    habitado: 'habitado',
  },
  iluminacao: {
    poste: 'iluminação de poste',
    artificial: 'iluminação artificial',
  },
  pavimentacao: {
    sim: 'pavimentado',
    nao: 'não pavimentado',
  },
  tipoTrecho: {
    reta: 'em reta',
    rotatoria: 'em uma rotatória',
    semSaida: 'via sem saída',
    curva: 'em curva',
  },
  nivel: {
    aclive: 'aclive',
    plano: 'plano',
    declive: 'declive',
  },
  acostamento: {
    sim: 'com acostamento',
    nao: 'sem acostamento',
  },
  permissaoEstacionar: {
    sim: 'sendo permitido estacionar',
    nao: 'sendo proibido estacionar',
  },
  localSinistro: {
    rodEstadual: 'uma Rodovia Estadual',
    rodFederal: 'uma Rodovia Federal',
    avenida: 'uma avenida',
    rua: 'uma rua',
    vicinal: 'uma vicinal',
    fechado: 'um local fechado',
  },

  testemunhas: {
    sim: 'com testemunhas',
    nao: 'sem testemunhas',
  },

  monitoramento: {
    sim: 'com monitoramento eletrônico',
    nao: 'sem monitoramento',
  },

  vigilancia: {
    sim: 'com vigilância',
    nao: 'sem vigilância',
  },
  area: {
    residencial: 'em área residencial',
    comercial: 'em área comercial',
    comunidade: 'em uma comunidade',
    rural: 'em área rural',
    chacara: 'em uma chácara',
  },
};

export const RelatoOrgaos = async (data: any) => {
  return `Comparecemos ${orgaos.dptoPolicia[data.dptoPolicia] || '[..]'} ${
    data.ocorrencia == 'sim'
      ? (orgaos.ocorrencia[data.ocorrencia] || '[..]') +
        ' Nº ' +
        (data.numeroOcorrencia || '[..]') +
        ' envolvendo o veículo do ' +
        (data.segurado || '[..]')
      : orgaos.ocorrencia[data.ocorrencia] || '[..]'
  } ${orgaos.concessionaria[data.concessionaria] || '[..]'} ${
    orgaos.corpoDeBombeiros[data.corpoDeBombeiros] || '[..]'
  } ${orgaos.hospital[data.hospital] || '[..]'}`;
};

export const orgaos = {
  dptoPolicia: {
    militar: 'na Polícia Militar',
    rodoviária: 'na Polícia Rodoviária',
    copom: 'no Comitê de Polícia Monetária',
    gcm: 'na Guarda Civil Metropolitana',
    civil: 'na Polícia Civil',
  },
  ocorrencia: {
    sim: 'onde confirmamos o boletim de ocorrência',
    nao:
      'onde confirmamos que não consta boletim de ocorrência envolvendo o veiculo segurado ou reclamante.',
  },
  corpoDeBombeiros: {
    sim: `Comparecemos a sede do Corpo de Bombeiros [estação selecionada pelo prestador] para solicitar a certidão de sinistro onde a [...] afirmou que a perfilada havia retirado o referido documento no dia [...]

      Verificamos que na certidão de sinistro nº. [...] consta que a ocorrência ocorreu no dia [...] ás [...] e que [...]`,
    nao: `Comparecemos a sede do Corpo de Bombeiros [estação selecionada pelo prestador] para solicitar a certidão de sinistro onde a [...] afirmou que não houve registro do documento de atendimento.`,
  },
  concessionaria: {
    sim: `Comparecemos na concessionaria  e [...]`,
    nao: '',
  },
  hospital: {
    publico: `No dia [...] comparecemos ao [estação selecionada pelo prestador] onde solicitamos cópia da ficha de atendimento do segurado e sua retirada ficou agendada para o dia [...].

No dia [...] retiramos a cópia do prontuário médico de nº. [...] e na anmnese consta o seguinte relato;
[...].
No referido prontuário não consta nenhum relato de ingestão de álcool ou drogas. Anexo I.
[...]
`,
    privado: `No dia [...] comparecemos ao [estação selecionada pelo prestador] onde solicitamos cópia da ficha de atendimento do segurado e sua retirada ficou agendada para o dia [...].

No dia [...] retiramos a cópia do prontuário médico de nº. [...] e na anmnese consta o seguinte relato;
[...].
No referido prontuário não consta nenhum relato de ingestão de álcool ou drogas. Anexo I.
[...]
`,
    na: '',
  },
};
